import { ABOUT_NAV_LINKS } from './hiraysHomeStatic'

export const NEWS_TYPES = {
  0: 'Tech Wiki',
  1: 'Company News',
  2: 'Exhibition',
  3: 'Industry News',
  4: 'Social Responsibility'
}

export const ABOUT_NAV = [
  { slug: 'company-intro', title: 'Company Introduction', type: 0 },
  { slug: 'history', title: 'Development History', type: 2 },
  { slug: 'culture', title: 'Corporate Culture', type: 3 },
  { slug: 'honors', title: 'Honors & Qualifications', type: -1 },
  { slug: 'careers', title: 'Careers', type: 6 }
]

export const SERVICE_NAV = [
  { slug: 'product-support', title: 'Product Support', type: 0 },
  { slug: 'value-added', title: 'Value-added Services', type: 2 },
  { slug: 'faq', title: 'FAQ', type: 3 }
]

export const NEWS_NAV = [
  { slug: 'tech-wiki', title: 'Tech Wiki', type: 0 },
  { slug: 'company-news', title: 'Company News', type: 1 },
  { slug: 'exhibition', title: 'Exhibition', type: 2 },
  { slug: 'industry', title: 'Industry News', type: 3 },
  { slug: 'social', title: 'Social Responsibility', type: 4 }
]

export const SOLUTION_ICONS = [
  { icon: '?', title: 'Detector', desc: 'Full precision matrix sealing testers' },
  { icon: '?', title: 'Test Fixture', desc: 'Customized test fixtures for various products' },
  { icon: '?', title: 'Test Platform', desc: 'Integrated one-stop test platform solutions' }
]

export function newsTypeLabel(type) {
  return NEWS_TYPES[type] || 'News'
}

export function newsPath(slug) {
  const item = NEWS_NAV.find(n => n.slug === slug)
  return item ? '/news/' + slug + '/' : '/news/'
}

export function aboutPath(slug) {
  const link = ABOUT_NAV_LINKS.find(a => a.slug === slug)
  const hash = link && link.hash ? '#' + link.hash : ''
  return hash ? '/about/' + hash : '/about/'
}

export function productPath(slug) {
  return slug ? '/product/' + slug + '/' : '/product/'
}

export function productDetailPath(catSlug, id) {
  return '/product/' + catSlug + '/' + id + '.html'
}

export function newsDetailPath(slug, id) {
  return '/news/' + slug + '/' + id + '.html'
}
